import dayjs, { type Dayjs } from 'dayjs';
import isNil from 'lodash/fp/isNil';

export const getLastUpdatedDate = (
  accounts: {
    snapshotSyncStatus: {
      latestSuccessfulTime?: string | null;
    };
  }[]
): Dayjs | null => {
  return dayjs.max(
    accounts
      .filter(
        (
          acc
        ): acc is {
          snapshotSyncStatus: {
            latestSuccessfulTime: string;
          };
        } => !isNil(acc.snapshotSyncStatus.latestSuccessfulTime)
      )
      .map((wall) => dayjs(wall.snapshotSyncStatus.latestSuccessfulTime))
  );
};

export const calculateAvailableAccountSubAccountIds = ({
  allSubFunds,
  allAccounts,
  subFundIds,
  accountIds,
  subAccountIds,
}: {
  allSubFunds: {
    id: number;
    subAccounts: {
      id: string;
    }[];
    accounts: {
      id: string;
    }[];
  }[];
  allAccounts: {
    id: string;
    subAccounts: {
      id: string;
    }[];
  }[];
  subFundIds: number[];
  accountIds: string[];
  subAccountIds: string[];
}): {
  filteredSubAccountIds: string[];
  subFundAvailableAccountIds: string[];
  accountAvailableSubAccountIds: string[];
  filteredAccountIds: string[];
} => {
  let filteredAccountIds = allAccounts.map((account) => account.id);
  let filteredSubAccountIds = allAccounts.flatMap((account) => account.subAccounts.map((subAccount) => subAccount.id));
  const accountIdToSubAccountIds = new Map(
    allAccounts.map((acc) => [acc.id, acc.subAccounts.map((subAcc) => subAcc.id)])
  );

  if (subFundIds.length > 0) {
    const subFunds = allSubFunds.filter((subFund) => subFundIds.includes(subFund.id));
    filteredAccountIds = filteredAccountIds.filter((accountId) =>
      subFunds.some((subFund) => subFund.accounts.some((account) => account.id === accountId))
    );

    filteredSubAccountIds = filteredSubAccountIds.filter((subAccountId) =>
      subFunds.some(
        (subFund) =>
          subFund.subAccounts.some((subAccount) => subAccount.id === subAccountId) ||
          subFund.accounts.some((account) => accountIdToSubAccountIds.get(account.id)?.includes(subAccountId))
      )
    );
  }

  const subFundAvailableAccountIds = filteredAccountIds;
  if (accountIds.length > 0) {
    filteredAccountIds = filteredAccountIds.filter((accountId) => accountIds.includes(accountId));
    filteredSubAccountIds = filteredSubAccountIds.filter((subAccId) => {
      return filteredAccountIds.some((accId) => accountIdToSubAccountIds.get(accId)?.includes(subAccId));
    });
  }

  const accountAvailableSubAccountIds = filteredSubAccountIds;
  if (subAccountIds.length > 0) {
    filteredSubAccountIds = filteredSubAccountIds.filter((subAccountId) => subAccountIds.includes(subAccountId));
  }

  return {
    accountAvailableSubAccountIds: accountAvailableSubAccountIds,
    subFundAvailableAccountIds: subFundAvailableAccountIds,
    filteredSubAccountIds: filteredSubAccountIds,
    filteredAccountIds: filteredAccountIds,
  };
};
